export * from "../../base/store/getters";

export function get_option_source(state) {
	return state.option_source;
}

export function get_option_source_dependent(state) {
	return state.option_source_dependent;
}

export function get_option_source_dependent_filter_key(state) {
	return state.option_source_dependent_filter_key;
}

export function get_options(state) {
	return state.options;
}
